<template>
    <div class="convention-obligations">
        <convention-sections-filters
            :cspFilters="cspFilters"
            :isAllCsp="convention.cspConfig.allIncluded"
            :convention="convention"
            @change="onCspFiltersChange"
        >
            <template v-slot:tab-label>
                <div class="tab-label">
                    <compact-info-icon />
                    {{ $privateDico.convention.menu["compact-info"].label }}
                </div>
            </template>
        </convention-sections-filters>
        <main-container>
            <v-row class="convention-sections">
                <v-col cols="3">
                    <convention-compact-info-table-of-contents
                        :convention="conventionWithCompactInfoAnnotationsOnly"
                    />
                </v-col>
                <v-col cols="9">
                    <convention-compact-info-annotations
                        :cspFilters="cspFilters"
                        :convention="conventionWithCompactInfoAnnotationsOnly"
                        :insurers="insurers"
                        :annotationOptions="annotationOptions"
                        :sections="convention.sections"
                    />
                </v-col>
            </v-row>
        </main-container>
    </div>
</template>

<script>
import ConventionCompactInfoTableOfContents from "./tableOfContents/ConventionCompactInfoTableOfContents.vue";
import compactInfoManager from "./managers/compactInfoManager";
import ConventionSectionsFilters from "../obligations/filters/ConventionSectionsFilters.vue";
import ConventionCompactInfoAnnotations from "./ConventionCompactInfoAnnotations.vue";
import { Services } from "src/services/Services";
import { head, get } from "lodash";
import CompactInfoIcon from "src/components/common/icons/CompactInfoIcon.vue";
import userMixin from "src/mixins/user";
import scrollManager from "src/components/convention/managers/scrollManager.js";

export default {
    components: {
        ConventionCompactInfoTableOfContents,
        ConventionCompactInfoAnnotations,
        ConventionSectionsFilters,
        CompactInfoIcon,
    },
    mixins: [userMixin],
    props: ["convention", "user"],
    data() {
        return {
            cspFilters: get(this.convention, "cspConfig.availableCodes", []),
            sectionsContainer: null,
            currentSelectedIds: null,
        };
    },
    created() {
        if (!this.isSubscribedToCompactInfo) this.$router.push({ name: "convention-presentation" });
    },
    mounted() {},
    methods: {
        onCspFiltersChange(cspFilters) {
            if (cspFilters.length > 0) {
                this.cspFilters = cspFilters;
                if (this.currentSelectedIds) {
                    const id = head(this.currentSelectedIds);
                    // Wait until content is updated on the page and then scroll
                    setTimeout(() => {
                        scrollManager.scrollToId(id);
                    }, 100);
                }
            }
        },
    },
    computed: {
        conventionWithCompactInfoAnnotationsOnly() {
            return {
                ...this.convention,
                annotationsByTitlePath: compactInfoManager.filterCompactInfoAnnotations(
                    this.convention
                ),
            };
        },
    },
    asyncComputed: {
        async insurers() {
            return await Services.api.insurer.getAllInsurers();
        },
        async annotationOptions() {
            return await Services.api.annotationOption.getAll();
        },
    },
    watch: {
        convention() {
            this.cspFilters = get(this.convention, "cspConfig.availableCodes", []);
            this.onCspFiltersChange(this.cspFilters);
        },
    },
};
</script>

<style scoped lang="sass">
.convention-obligations
    background: $color-background
    padding: $grid-gutter/2 0
.tab-label
    display: flex
    align-items: center
</style>
